export const getFormattedDate = (date) => {
	let today = new Date(date);
	var hours = today.getHours();
	var minutes = today.getMinutes();
	var ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? '0' + minutes : minutes;
	var strTime = hours + ':' + minutes + ' ' + ampm;
	let date1 = today.getDate() + "-" + parseInt(today.getMonth() + 1) + "-" + today.getFullYear();

	return date1;
};

export const toTitle = (string) => {
	return string.split('-')
		.map(word => {
			return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase()
		})
		.join(' ')
}

export const isNanHandler=(args)=>{
	let number
	number = isNaN(args)? 0 : args
	return number
}


export const numberFormat = (value) => {

	return new Intl.NumberFormat('en-IN', {
		style: 'currency',
		currency: 'INR'
	}).format(isNaN(value)? 0 : value);
}

export const valueErrorHandler = (args) => {
	let value
	if (args !== null && args !== undefined) {
		value = args
	} else {
		value = ""
	}
	return value
}


export const NonEmptyArray=(args)=>{
	let value = args
	return value !== null && value.edges.length > 0
}
